








































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";

@Component
export default class SurveyCompletedDialog extends Vue {
  @Ref("new-survey-completed-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: String, required: true })
  subtitle!: string;

  @Prop({ type: String, required: true })
  exitButton!: string;

  @Prop({ type: String, required: true })
  routeButton!: string;

  onSubmit() {
    this.$emit("ok", true);
    this.hide();
  }

  onCancelButton() {
    this.$emit("ok", false);
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
